module.exports = __webpack_public_path__ + "img/安全标准提案.5ccc32b2.png";